// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3fK4hkR1K00DXm {\n  padding: 26px;\n  box-sizing: border-box;\n}\n._1YbJA5N9H5wa-q {\n  display: flex;\n  margin: 16px auto;\n}\n._10qSkBd6Opur_c {\n  display: flex;\n  margin: 24px auto;\n  width: 170px;\n  height: 120px;\n}\n._1XqIMcnehA7ehg {\n  text-align: center;\n  margin: 8px auto;\n}\n._3z_oyGufJ4rZrS {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_3fK4hkR1K00DXm",
	"modalImageButton": "_1YbJA5N9H5wa-q",
	"modalImage": "_10qSkBd6Opur_c",
	"modalTitle": "_1XqIMcnehA7ehg",
	"modalText": "_3z_oyGufJ4rZrS"
};
export default ___CSS_LOADER_EXPORT___;
